module.exports = __webpack_public_path__ + "img/poly-9.8c605e0c.png";